/**
 * 公共的跨组件通信
 * @Author: FJJ
 * @History:
 * @Date      Version Remarks
 * ========= ======= ======================================================
 * 2022      1.0     First version  提供的Context
 *
 * Copyright 2022, all rights reserved. Essa.cn
 */
import React  from "react";
const { createContext } = React;
export default createContext({
    __authState:{},
    _extraState:{},
})